import { PUBLIC_VIEW_KEY_LENGTH } from './encryption';

// Size (in bytes) of the message length prefix (2 bytes, big-endian)
export const MESSAGE_LENGTH_PREFIX_LENGTH = 2

// Size (in bytes) of the conversation identifier
export const CONVERSATION_ID_LENGTH = 16

// Size (in bytes) of the HMAC-based sender proof
export const SENDER_PROOF_LENGTH = 32

// Total size of the unencrypted message header
export const MESSAGE_HEADER_SIZE =
  MESSAGE_LENGTH_PREFIX_LENGTH +
  CONVERSATION_ID_LENGTH +
  SENDER_PROOF_LENGTH +
  PUBLIC_VIEW_KEY_LENGTH + // senderNextViewPublicKey
  PUBLIC_VIEW_KEY_LENGTH   // senderViewPublicKey

// Maximum size (in bytes) of the entire encrypted data frame
export const MAX_PAYLOAD_SIZE = 700